
import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
    Divider,
    colors,
    Button
} from '@material-ui/core';

import {
    Alert
} from '@material-ui/lab';

import {
    FieldError
} from '../../../common';

import {
    ResetSettingsDialog
} from './Dialogs';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    Switch,
    TextField,
    CheckboxWithLabel
} from 'formik-material-ui';

import { PageContext } from '../PageContext';

import { getColoredBottonStyle } from '../../../../helpers';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';

// wpApAdminSettings is a global variable defined in WP
// To allow webpack to build and not giving error we are
// creating a local reference only if it exists 
// (basically when the javascript is executed inside the WordPress context)
let _wpApAdminSettings = {};
if (typeof variable !== 'wpApAdminSettings') {
   _wpApAdminSettings = window['wpApAdminSettings'];
}

const useStyles = makeStyles((theme) => ({
    root: {
    },
    title: {
        fontSize: "1.2em"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    },
    resetButton: {
        ...getColoredBottonStyle(theme, colors.red)
    },
}));



export const WelcomeForm = ({
    formRef,
    errors,
    validationSchema,
    reset,
    disabled,
    onBlur,
    onSubmit,
    ...props }) => {
    const classes = useStyles();

    const { t, i18n } = useTranslation();

    const [openResetDialog, setOpenResetDialog] = useState(false);

    const {
        state
    } = useContext(PageContext);

    const {
        settings
    } = state;


   const getAssetUrl = (assetPath) => {
      return `${_wpApAdminSettings.assetsUrl}/${assetPath}`;
   }

    const getInitialValues = () => {
        return {};
    }

    const resetClickHandler = (e) => {
        setOpenResetDialog(true);
    }

    const confirmResetHandler = () => {
        setOpenResetDialog(false);
        if (reset) reset();
    }

    const submitClickHandler = (values, actions) => {
        if (onSubmit) onSubmit(values, () => actions.setSubmitting(false));
    }

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardContent>
                <Container maxWidth="lg" className={classes.content}>
                    <Formik
                        enableReinitialize
                        initialValues={getInitialValues()}
                        onSubmit={submitClickHandler}
                        innerRef={formRef}
                        validationSchema={validationSchema}
                        validateOnChange={false}
                        validateOnBlur={true}
                        validate={(values) => {
                            if (onBlur) onBlur(values);
                        }}>
                        {(props) => {
                            const {
                                values,
                                isSubmitting,
                                handleSubmit,
                                setFieldValue
                            } = props;
                            return (
                                <Form noValidate autoComplete="off">
                                    <Grid container spacing={3}>

                                     <Grid item xs={12} style={{ }}>
                                        <Typography variant="h5" component="h2" textAlign="middle">

                                              <img style={{ width: '50px', height: 'auto', marginRight: '20px' }} src={getAssetUrl("images/flag.png")}></img>

                                           {t("LabelWelcome0")}
                                        </Typography>
                                     </Grid>
                                     <Grid item xs={12}>
                                        <Typography>
                                           {t("LabelWelcome1")}
                                        </Typography>
                                        <br />

                                        <div style={{ display: 'flex', 'justify-content': 'center' }}>
                                           <a href="https://apps.apple.com/it/app/myliveviewer/id1539795908?itsct=apps_box_badge&amp;itscg=30200" target="_blank">
                                              <img style={{ margin: '10px', width: '138px', height: 'auto'}} src={getAssetUrl("images/apple_store_badge.avif")} alt="Download on the App Store"></img>
                                           </a>
                                           <a href="https://play.google.com/store/apps/details?id=com.teamonair.myFastAppLiveViewer&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1" target="_blank">
                                              <img style={{ margin: '10px', width: '154px', height: 'auto'}} src={getAssetUrl("images/google_play_badge.avif")} alt="Get it on Google Play"></img>
                                           </a>
                                        </div>

                                        <br />

                                        <Typography>
                                           {t("LabelWelcome2")}
                                        </Typography>

                                        <br />

                                        <Typography>
                                           {t("LabelWelcome3")}
                                        </Typography>

                                        <br />

                                        <Typography>
                                           {t("LabelWelcome4")}
                                        </Typography>

                                        <br />

                                        <Typography>
                                           {t("LabelWelcome5") + " "}
                                           <a href="https://myfastapp.com/app-building-getting-started-with-my-fastapp/" target="_blank">TUTORIAL</a>
                                        </Typography>

                                     </Grid>



                                    </Grid>

                                    <ResetSettingsDialog
                                        open={openResetDialog}
                                        onConfirm={(e) => confirmResetHandler()}
                                        onClose={(e) => setOpenResetDialog(false)}
                                    />

                                </Form>
                            );
                        }}
                    </Formik>
                </Container>
            </CardContent>
        </Card>
    );
}